/// <amd-module name="Wit/SprintsHub/SprintsView/Services/ICapacityService" />
import { ITeamSettings } from "Agile/Contracts/Common";
import { IObservable, IObservableArray, IObservableValue, ObservableArray } from "VSS/Core/Observable";
import { IVssService } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IIdentity } from "VSSUI/IdentityPicker";
import { DateRange, TeamMemberCapacityIdentityRef } from "Wit/Clients/Work/Contracts/Work";
import { ISprintCapacityOptions } from "Wit/SprintsHub/Common/Contracts/Interfaces";

export enum CapacityRevisionActions {
    RemoveRow = "remove-row",
    Capacity = "capacity",
    Activity = "activity",
    DaysOff = "days-off"
}

export interface IUserActivity extends Pick<TeamMemberCapacityIdentityRef, "_links" | "url"> {
    activityName: IObservableValue<string>;
    capacityPerDay: IObservableValue<string>;
    daysOff?: IObservableArray<DateRange>;
    teamMember?: IdentityRef;
}

export interface ICapacityService extends IVssService {
    addActivity(activityRow: IUserActivity, index: number): void;
    addUser(identity: IIdentity): void;
    getCapacityCommandBarItems(teamSettings: ITeamSettings, iterationId: string): IHeaderCommandBarItem[];
    getCapacityOptions(): ISprintCapacityOptions | undefined;
    getChangeObservable(): IObservable<number>;
    getMemberCapacities(): IObservableArray<IUserActivity>;
    getWaitingObservable(): IObservableValue<boolean>;
    getTeamDaysOff(): DateRange[];
    getTeamDaysOffObservable(): ObservableArray<DateRange>;
    /**
     * Loads the capacity data from the rest endpionts. Will return false without updating
     * if none of the params change from last call
     * @param teamId
     * @param projectId
     * @param iterationId
     */
    loadCapacityData(teamId: string, projectId: string, iterationId: string): Promise<boolean>;
    removeActivity(index: number): void;
    removeUser(teamMemberId: string): void;
    updateActivity(userActivity: IUserActivity, activityName: string): void;
    updateCapacity(userActivity: IUserActivity, capacity: string): void;
    updateDaysOff(userActivity: IUserActivity, daysOff?: DateRange[]): void;
}
